import tryoutSeal from "resources/img/sellos_7_dias.png";
import warrantySeal from "resources/img/sellos_garantia_mecanica.png";
import "./styles.scss";

const Seals = () => (
  <div className="seals">
    <a
      href="/useds/Terminos y condiciones.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={tryoutSeal} alt="7 días de prueba" />
      <img src={warrantySeal} alt="Garantía mecánica de 12 meses" />
    </a>
  </div>
);

export default function NotSeals() {
  return null;
}
